import { render } from "./WikiHome.vue?vue&type=template&id=aa5a3558&scoped=true"
import script from "./WikiHome.vue?vue&type=script&lang=js"
export * from "./WikiHome.vue?vue&type=script&lang=js"

import "./WikiHome.vue?vue&type=style&index=0&id=aa5a3558&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa5a3558"]])

export default __exports__